import { MdKeyboardBackspace } from "react-icons/md";
import RouterLink from "./RouterLink";
import { forwardRef } from "react";
import { LinkProps, To } from "react-router-dom";

export interface BackLinkProps extends Omit<LinkProps, 'to'> {
  to?: To;
};

// TODO: to = -1 works but is not supposed to
const BackLink = forwardRef<HTMLAnchorElement, BackLinkProps>(({ to = -1, relative = "path", ...props }: BackLinkProps, ref) => {
  return (
    <RouterLink
      ref={ref}
      to={to}
      relative={relative}
      {...props}
      sx={{
        mr: [1, 1, 2],
        display: 'flex',
        alignItems: 'center',
        color: 'unset'
      }}
    >
      <MdKeyboardBackspace size={30} />
    </RouterLink>
  );
});

export default BackLink;
